import { render, staticRenderFns } from "./EditDistributor.vue?vue&type=template&id=575a9af6&"
import script from "./EditDistributor.vue?vue&type=script&lang=js&"
export * from "./EditDistributor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports